import { render, staticRenderFns } from "./ArchiveIcon.vue?vue&type=template&id=032cdce6&scoped=true&"
import script from "./ArchiveIcon.vue?vue&type=script&lang=js&"
export * from "./ArchiveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032cdce6",
  null
  
)

export default component.exports